/* eslint-disable @eslint-react/no-array-index-key */
import { FC } from 'react';

import { DocumentOrderLineData, InvoiceResponse, OrderDocumentType } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { InvoiceContent } from './invoice-content';

interface Props {
   invoices: Array<InvoiceResponse>;
   showInvoiceDocuments: boolean;
   onDownload: (document: InvoiceResponse, orderLineData: DocumentOrderLineData, type: OrderDocumentType) => void;
   onViewDocument: (document: InvoiceResponse, orderLineData: DocumentOrderLineData) => void;
}

export const InvoiceAndCreditNotes: FC<Props> = ({ invoices, showInvoiceDocuments, onDownload, onViewDocument }) => {
   const translate = useTranslations();

   if (!showInvoiceDocuments) {
      return (
         <Box direction="column" gap="sm">
            <Paper direction="row" width="100%">
               <Typography variant="body" component="span">
                  {translate('permissions.no-view-invoice-documents-permission')}
               </Typography>
            </Paper>
         </Box>
      );
   }

   return (
      <Box direction="column" gap="sm">
         {invoices.length > 0 ? (
            invoices.map((invoice, index) => (
               <Paper direction="row" key={index} width="100%">
                  <Box justify="between" items="start" width="100%">
                     <InvoiceContent data={invoice} onDownload={onDownload} onViewDocument={onViewDocument} />
                  </Box>
               </Paper>
            ))
         ) : (
            <Typography variant="body" component="span">
               {translate('shipment.documents.no-documents-available')}
            </Typography>
         )}
      </Box>
   );
};
